import axios from "config/axios/base";
import qs from "qs";

export const patchUser = ({ params = {}, body = {}, options = null }) =>
	axios.post(
		`/users/update${params?.id ? `/${params?.id}` : ""}?${qs.stringify({ _method: "PATCH" })}`,
		body,
		options
	);
export const patchUsers = ({ params: { id } = {}, body = {}, options = null }) =>
	axios.patch(`/users/update/${id}`, body, options);
export const getUsers = ({ query = {}, options = null }) => axios.get(`/users?${qs.stringify(query)}`, options);
export const postUsers = ({ body = {}, options = null }) => axios.post(`/users/store`, body, options);
export const deleteUsers = ({ params = {}, query = {}, options = null }) =>
	axios.delete(`/users/destroy/${params?.id}?${qs.stringify(query)}`, options);
export const getUser = ({ params = {}, options = null }) => axios.get(`/users/show/${params?.id}`, options);
export const getUserSchedule = ({ params = {}, options = null }) => axios.get(`/users/${params?.id}/schedule`, options);
export const putUserSchedule = ({ params = {}, body = {}, options = null }) =>
	axios.put(`/users/${params?.id}/schedule`, body, options);
export const resendEmailVerificationCode = ({ options = null }) => axios.get("/user/email/resend", options);
// The backend signs the verify link: send `expires` and `signature` exactly as received, in this
// order and with nothing else, or the signature no longer matches.
export const verifyEmailToken = ({ params = {}, query = {}, options = null }) => {
	const signed =
		query?.expires && query?.signature
			? `?expires=${encodeURIComponent(query.expires)}&signature=${encodeURIComponent(query.signature)}`
			: "";

	return axios.get(`/user/email/verify/${params?.token}${signed}`, options);
};
export const getMemberFilterOptions = ({ query = {}, options = null }) =>
	axios.get(`/users/member-filter-options?${qs.stringify(query)}`, options);
